import { UserModel } from '../user/user.model';
import { JsonProperty, ProblemModel, TopicModel } from '..';

class StudentModel extends UserModel.Complete {
  stripeId: string = undefined;
  keapId: string = undefined;
  ghlId: string = undefined;
  phoneNumber: string = undefined;
  demographicsComplete: boolean = undefined;
  birthdate: number = undefined;
  graduationYear: number = undefined;

  currentScoreEnglish: number = undefined;
  currentScoreMath: number = undefined;
  currentScoreReading: number = undefined;
  currentScoreScience: number = undefined;

  goalScoreEnglish: number = undefined;
  goalScoreMath: number = undefined;
  goalScoreReading: number = undefined;
  goalScoreScience: number = undefined;
}

class StudentAnswerResponse {
  studentId: number = undefined;
  isCorrect: boolean = undefined;
  correctAnswer: string = undefined;
}

class StrategyResponse {

  @JsonProperty({ clazz: ProblemModel })
  problem: ProblemModel = undefined;

  @JsonProperty({ clazz: TopicModel })
  topics: TopicModel[] = [];

}

class StudentSmartSavers {
  cutIncorrect: number = undefined;
  stopTimer: number = undefined;
  getHint: number = undefined;
}

class StudentAskTutor {
  studentId: number = undefined;
  body: string = undefined;
  feedback: string = undefined;
}

export { StudentModel, StudentAnswerResponse, StudentSmartSavers, StudentAskTutor, StrategyResponse};
